import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MultipleEmailValidator, SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { SameWordEmailValidator } from "src/app/directives/same-word-email.directive";
import { BoletaHonorariosEmitida } from "src/app/models/BoletaHonorarios/BoletaHonorariosEmitida";
import { BoletaHonorariosRecibida } from "src/app/models/BoletaHonorarios/BoletaHonorariosRecibida";
import { EmailBH } from "src/app/models/BoletaHonorarios/EmailBH";

@Component({
   selector: "app-envio-bhe-correo",
   templateUrl: "./envio-bhe-correo.component.html",
   styleUrls: ["./envio-bhe-correo.component.scss"],
})
export class EnvioBheCorreoComponent implements OnInit {
   @Input() public bheEmitida: BoletaHonorariosEmitida;
   @Input() public emitida: boolean;
   @Input() public bheRecibida: BoletaHonorariosRecibida;
   @Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
   @Output() private sendEmailBHERequest: EventEmitter<any> = new EventEmitter<any>();

   public emailRequestFormGroup: FormGroup;
   constructor(private formBuilder: FormBuilder) {
      this.createEmailForm();
   }

   ngOnInit(): void {}

   createEmailForm() {
      this.emailRequestFormGroup = this.formBuilder.group(
         {
            receiverEmail: ["", [Validators.required, MultipleEmailValidator, Validators.maxLength(320)]],
            ccEmail: ["", [MultipleEmailValidator, Validators.maxLength(320)]],
            ccoEmail: ["", [MultipleEmailValidator, Validators.maxLength(320)]],
            sendPdfCheckbox: [true],
            sendXmlCheckbox: [true],
         },
         { validators: SameWordEmailValidator }
      );
   }
   sendCloseRequest() {
      this.sendCloseRequestEmitter.emit();
   }

   sendEmailRequest() {
      if (this.emailRequestFormGroup.valid) {
         let validEmail: string[] = this.emailRequestFormGroup.controls.receiverEmail.value.toString().split(",");
         let emailsCCs: string[] = this.emailRequestFormGroup.controls.ccEmail.value ? this.emailRequestFormGroup.controls.ccEmail.value.toString().split(",") : [];
         let emailCCOs: string[] = this.emailRequestFormGroup.controls.ccoEmail.value ? this.emailRequestFormGroup.controls.ccoEmail.value.toString().split(",") : [];
         let request: EmailBH = new EmailBH();
         request.to = validEmail;
         request.cCOs = emailCCOs;
         request.cCs = emailsCCs;
         request.emitida = this.emitida;
         request.bHId = this.emitida ? this.bheEmitida.boletaHonorarioId : this.bheRecibida.boletaHonorarioId;
         this.sendEmailBHERequest.emit(request);
      }
   }
}
